import calculatorjs from './assets/images/calcalutorjs.png'
import calculatorreact from './assets/images/calculatorreact.png'
import hangman from './assets/images/hangman.png'
import dadjokes from './assets/images/dadjokes.png'
import todoapp from './assets/images/todoapp.png'
import crystals from './assets/images/crystals.png'
import library from './assets/images/library.png'

export const projects = [
    {
        img: library,
        prlanguage: "JS, Firebase, HTML, CSS",
        title: "Library",
        about: "Searching for books and other assortments. Available in the admin panel",
        github: "https://github.com/Ali-Sadygov/library.com",
        live: "https://ali-sadygov.github.io/library.com/"
    },
    {
        img: dadjokes,
        prlanguage: "React, Redux-Toolkit, MaterialUI",
        title: "Dad-Jokes",
        about: "Jokes written with API",
        github: "https://github.com/Ali-Sadygov/Dad-Jokes-React",
        live: "https://dad-jokes-react.netlify.app/"
    },
    {
        img: todoapp,
        prlanguage: "React, Context-Api, CSS",
        title: "Todo-App",
        about: "Only focused logic",
        github: "https://github.com/Ali-Sadygov/React-Todo-App?tab=readme-ov-file",
        live: "https://to-do-app-react-js-deploy.netlify.app/"
    },
    {
        img: calculatorreact,
        prlanguage: "React, Context-Api, CSS",
        title: "Calculator",
        about: "Calculator App",
        github: "https://github.com/Ali-Sadygov/React-Calculator",
        live: "https://ali-sadygov.github.io/React-Calculator/"
    },
    {
        img: calculatorjs,
        prlanguage: "JS, jQuery, HTML, CSS",
        title: "Calculator",
        about: "Calculator App",
        github: "https://github.com/Ali-Sadygov/calculator",
        live: "https://ali-sadygov.github.io/calculator/"
    },
    {
        img: hangman,
        prlanguage: "JS, HTML, CSS",
        title: "Hangman Game",
        about: "You can only play with the computer",
        github: "https://github.com/Ali-Sadygov/hangman-game",
        live: "https://ali-sadygov.github.io/hangman-game/"
    },
    {
        img: crystals,
        prlanguage: "JS, HTML, CSS",
        title: "Crystals-Collector",
        about: "Crystals-Collector game , 1player",
        github: "https://github.com/Ali-Sadygov/crystals_collector",
        live: "https://ali-sadygov.github.io/crystals_collector/"
    },
] 